import { Button, Padding, Typography } from '@musinsa/mds';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ErrorAction {
  label: string;
  onClick: () => void;
}

interface ErrorContainerProps {
  logo?: ReactNode;
  title: string;
  description: ReactNode;
  actions?: ErrorAction[];
  className?: string;
}

export function ErrorContainer({
  logo,
  title,
  description,
  actions = [],
  className,
}: ErrorContainerProps) {
  return (
    <div
      className={twMerge(
        'bg-white flex flex-col items-center justify-between min-h-screen w-full bg-[#F5F5F5]',
        className,
      )}
    >
      <Padding x="4" className="flex h-[52px] w-full items-center justify-center">
        {logo}
      </Padding>
      <Padding x="4" y="10" className="flex flex-col gap-[12px]">
        <div className="flex flex-col gap-[2px] items-center text-center w-full">
          <Typography variant="body14pxMed" colorScheme="black" className="leading-5">
            {title}
          </Typography>
          <div className="text-center">{description}</div>
        </div>

        {actions.length > 0 && (
          <div className="flex gap-2 items-center justify-center">
            {actions.map((action, index) => (
              <Button key={index} variant="secondary" size="36" onClick={action.onClick}>
                <Typography variant="body13pxMed">{action.label}</Typography>
              </Button>
            ))}
          </div>
        )}
      </Padding>

      <div />
    </div>
  );
}
